import { cn } from '@/lib/cn';

/**
 * FreshnessBanner - color-coded data-freshness strip below the topbar. The `state` maps 1:1 to the
 * `.freshness-banner` modifier classes (.fresh / .stale / .blocked); the `.dot` tints to match.
 * Member Care uses it for "Queue live as of HH:MM" + the live multi-operator refresh state.
 */

export type FreshnessBannerState = 'fresh' | 'stale' | 'blocked';

export interface FreshnessBannerProps {
  state: FreshnessBannerState;
  label: string;
}

export function FreshnessBanner({ state, label }: FreshnessBannerProps) {
  return (
    <div className={cn('freshness-banner', state)} role="status" aria-live="polite">
      <span className="dot" />
      <span>{label}</span>
    </div>
  );
}
